import { Component, Input } from '@angular/core';
import { environment } from '@environments/environment';
import { IntlService } from '@progress/kendo-angular-intl';
import { BaseCardComponent } from "./base-card.component";
import { AuthService } from '@app/core/services';
import { Router } from '@angular/router';


@Component({
  selector: 'credit-detail-card',
  styleUrls: ['./styles/styles-card.css'],
  styles: [`
    .card{
      height: 70px;
    }   
    .badge {
      padding: 0 4px 0 4px;
      color: white;
    }     
  `],
  template: `
    <!--{{credit | json}}-->
    <div class="card" [class.border-top]="borderTop" (click)="selectItem($event)">
      <kendo-avatar [imageSrc]="credit.type == 'SI' ? environment.assets.DEFAULT_SERVICE: environment.assets.DEFAULT_VEHICLE" shape="circle" style="background-size: contain; padding: 6px; background-color: #{{ credit.status_credit_color }}"></kendo-avatar>
      <div class="card-details">
        <div class="card-title">
          <span>{{ intl.formatNumber(credit.cost, "c2", "en") }}</span> 
          
          <span class="right">
            <span *ngIf="credit.status_payment != 'PAGADO'" class="badge" style="background-color: #{{ credit.status_credit_color }}">{{ credit.status_credit }}</span>
            <!--<span *ngIf="credit.status_payment == 'PAGADO'" class="badge" style="background-color: #{{ credit.status_payment_color }}">{{ credit.status_payment }}</span>-->
          </span>
        </div>                
        <div class="card-subtitle no-wrap">
          {{ credit.name }} 
          <span *ngIf="credit.status_payment != 'PAGADO'" class="right text-success"> Pagado: {{ intl.formatNumber(credit.credit_paid, "c2", "en") }}</span>
        </div>
        <div class="card-subtitle no-wrap">
          {{ getDate(credit.expiration_date, false) }} 
          <span *ngIf="credit.status_payment != 'PAGADO'" class="right text-danger"> Pendiente: {{ intl.formatNumber(credit.credit_pending, "c2", "en") }}</span>
        </div>
        <div *ngIf="credit.status_payment != 'PAGADO'" class="card-subtitle no-wrap">
          {{ credit.credit_days_left > 0 ? 'Hace': 'Faltan'}} {{ credit.credit_days_left > 0 ? credit.credit_days_left: -credit.credit_days_left }} días <span class="right"> {{ (credit.credit_payments) ? credit.credit_payments: 0 }} Pagos</span>
        </div>  
        <div *ngIf="credit.status_payment == 'PAGADO'" class="card-subtitle no-wrap">
          {{ (credit.credit_payments) ? credit.credit_payments: 0 }} Pagos
        </div>      
      </div>
      <!--<div class="card-actions" *ngIf="authService.hasPermission(['CREDITOS:EDITAR','CREDITOS:ELIMINAR'])">
        <span class="k-icon k-icon-md k-i-arrow-chevron-right k-color-secondary" style="color: #{{ credit.credit_status_color }}!important"></span>
      </div>-->
    </div>
  `,    
})
export class CreditDetailCardComponent extends BaseCardComponent {

  @Input() credit!: any;

  @Input() returnUrl: string;

  public environment = environment;


  constructor(public intl: IntlService, public router: Router, public authService: AuthService) { 

    super(intl, router)

  }

  public selectItem(event: any) {

  //   this.router.navigate(['/credit_edit/' + this.credit.id], {state: {returnUrl: this.returnUrl}});

  }

}